export default "__VITE_ASSET__325a09b3__"